import React, { useRef, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { FiLogIn, FiMail } from 'react-icons/fi';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';

import { Input, Button, FadeContainer } from '../../components';

import logoImg from '../../assets/logo.svg';
import { Container, Background } from './styles';
import api from '../../services/api';

interface ForgotPasswordFormData {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: ForgotPasswordFormData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email é obrigatório')
            .email('Insira um email válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/password/forgot', {
          email: data.email,
        });

        addToast({
          type: 'success',
          title: 'Email de recuperação enviado',
          description:
            'Enviamos um email para confirmar a recuperação de senha. Verifique sua caixa de entrada',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const formErrors = getValidationErrors(err);
          formRef.current?.setErrors(formErrors);
          return;
        }
        addToast({
          type: 'error',
          title: 'Erro na recuperação de senha',
          description:
            'Ocorreu um erro ao tentar realizar a recuperação de senha, tente novamente',
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <Container>
      <FadeContainer time={2}>
        <img src={logoImg} alt="logo" />
        <Form
          ref={formRef}
          initialData={{
            email: 'contato@weblife.com.br',
          }}
          onSubmit={handleSubmit}
        >
          <h1>Recuperar Senha</h1>

          <Input icon={FiMail} name="email" placeholder="Email" />

          <Button type="submit" loading={loading}>
            Recuperar
          </Button>
        </Form>

        <Link to="/">
          <FiLogIn />
          Voltar ao login
        </Link>
      </FadeContainer>
      <Background />
    </Container>
  );
};

export default ForgotPassword;
